import { Type } from "@scalar/typebox";
import { ReferenceConfigSchema } from "../../schemas/reference-config/index.js";
const ConfigSchema = Type.Partial(
  Type.Object({
    "x-scalar-reference-config": ReferenceConfigSchema
  })
);
export {
  ConfigSchema
};
//# sourceMappingURL=config.js.map
